"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = void 0;
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const ActionTypes = require("../../actionTypes/bid/basicInformation");
const _BillingActionTypes = require("../../actionTypes/bid/billingInformations");
const initialBid = {
    name: '',
    description: '',
    startAt: null,
    endAt: null,
    buyer: {
        name: '',
        email: '',
        telephone: '',
        company: '',
        street: '',
        postalCode: '',
        city: '',
        vatNumber: ''
    },
    printOrders: {
        provideCopies: 0,
        finishing: null,
        billingInformation: null,
        approveRequired: false
    },
    procerement: {
        doNotReceiveTenders: false,
        preQualification: false,
        preQualificationDeadline: null,
        negotitation: false,
        negotitationEndAt: null,
        suitabilityAndFinancialProposals: false,
        lockTenders: false,
        openingEvent: false,
        openingEventAt: null,
        questionsAndAnswers: false,
        questionsAndAnswersDeadline: null,
        questionsAndAnswersPublishedAt: null,
        reliablePartnerReport: false
    }
};
exports.initialState = {
    saveStatus: 'STANDBY',
    updateStatus: 'STANDBY',
    saveOpeningEventStatus: 'STANDBY',
    errors: fp.option.none,
    openingEventErrors: fp.option.none,
    type: 'INITIAL',
    values: null,
    publish: false,
    step: 0,
    hasUnsavedChanges: false,
    hasOpeningEventChanged: false,
    savedValues: null
};
const saveStatusLens = monocle.Lens.fromProp('saveStatus');
const saveOpeningEventStatusLens = monocle.Lens.fromProp('saveOpeningEventStatus');
const errorsLens = monocle.Lens.fromProp('errors');
const openingEventErrorsLens = monocle.Lens.fromProp('openingEventErrors');
const updateStatusLens = monocle.Lens.fromProp('updateStatus');
const typeLens = monocle.Lens.fromProp('type');
const valuesLens = monocle.Lens.fromProp('values');
const savedValuesLens = monocle.Lens.fromProp('savedValues');
const buyerLens = monocle.Lens.fromProp('buyer');
const publishLens = monocle.Lens.fromProp('publish');
const printOrdersLens = monocle.Lens.fromProp('printOrders');
const procerementLens = monocle.Lens.fromProp('procerement');
const stepLens = monocle.Lens.fromProp('step');
const hasUnsavedChangesLens = monocle.Lens.fromProp('hasUnsavedChanges');
const hasOpeningEventChangedLens = monocle.Lens.fromProp('hasOpeningEventChanged');
const updateFieldLens = (key) => monocle.Lens.fromProp(key);
exports.methods = {};
exports.methods[ActionTypes.INIT] = (state, action) => {
    return fp.function.compose(valuesLens.set(action.payload.bid || Object.assign({}, initialBid)), typeLens.set(action.payload.bid ? 'UPDATE' : 'CREATE'), savedValuesLens.set(action.payload.bid || null))(state);
};
exports.methods[ActionTypes.UPDATE_BASIC_INFO] = (state, action) => {
    if (state.type === 'INITIAL')
        return state;
    const newState = fp.function.compose(valuesLens.modify(updateFieldLens(action.payload.field).set(action.payload.value)), errorsLens.modify((e) => e.fold(fp.option.none, (s) => {
        delete s[`${action.payload.field}`];
        return fp.option.some(s);
    })))(state);
    const changed = JSON.stringify(state.savedValues) !== JSON.stringify(newState.values);
    return hasUnsavedChangesLens.set(changed)(newState);
};
exports.methods[ActionTypes.UPDATE_BUYER_INFO] = (state, action) => {
    if (state.type === 'INITIAL')
        return state;
    const newState = valuesLens
        .compose(buyerLens)
        .modify(updateFieldLens(action.payload.field).set(action.payload.value))(state);
    const changed = JSON.stringify(state.savedValues) !== JSON.stringify(newState.values);
    return hasUnsavedChangesLens.set(changed)(newState);
};
exports.methods[ActionTypes.UPDATE_PRINT_ORDER_INFO] = (state, action) => {
    if (state.type === 'INITIAL')
        return state;
    const newState = valuesLens
        .compose(printOrdersLens)
        .modify(updateFieldLens(action.payload.field).set(action.payload.value))(state);
    const changed = JSON.stringify(state.savedValues) !== JSON.stringify(newState.values);
    return hasUnsavedChangesLens.set(changed)(newState);
};
exports.methods[ActionTypes.UPDATE_PROCEREMENT] = (state, action) => {
    if (state.type === 'INITIAL')
        return state;
    if (action.payload.field === 'doNotReceiveTenders' && action.payload.value) {
        const newState = valuesLens
            .compose(procerementLens)
            .set(Object.assign(Object.assign({}, initialBid.procerement), { doNotReceiveTenders: true }))(state);
        const changed = JSON.stringify(state.savedValues) !== JSON.stringify(newState.values);
        return hasUnsavedChangesLens.set(changed)(newState);
    }
    const newState = valuesLens
        .compose(procerementLens)
        .modify(updateFieldLens(action.payload.field).set(action.payload.value))(state);
    if (action.payload.field === 'openingEventAt') {
        if (state.savedValues) {
            if (state.savedValues.procerement) {
                if (state.savedValues.procerement.openingEventAt === action.payload.value) {
                    return hasOpeningEventChangedLens.set(false)(newState);
                }
                else {
                    return hasOpeningEventChangedLens.set(true)(newState);
                }
            }
        }
    }
    if (action.payload.field === 'openingEvent' &&
        action.payload.value === false) {
        if (state.savedValues &&
            state.savedValues.procerement.lockTenders === false) {
            const tempState = fp.function.compose(valuesLens
                .compose(procerementLens)
                .modify(updateFieldLens('lockTenders').set(false)), valuesLens
                .compose(procerementLens)
                .modify(updateFieldLens('openingEventAt').set(null)))(newState);
            const changed = JSON.stringify(state.savedValues) !== JSON.stringify(tempState.values);
            return hasUnsavedChangesLens.set(changed)(tempState);
        }
    }
    const changed = JSON.stringify(state.savedValues) !== JSON.stringify(newState.values);
    return hasUnsavedChangesLens.set(changed)(newState);
};
exports.methods[ActionTypes.SET_BASIC_INFORMATION] = (state, action) => {
    return valuesLens.set(Object.assign({}, action.payload.bid))(state);
};
exports.methods[ActionTypes.CLEAR] = (state, action) => (Object.assign({}, exports.initialState));
exports.methods[ActionTypes.CREATE_REQUEST] = (state, action) => fp.function.compose(errorsLens.set(fp.option.none), saveStatusLens.set('SAVING'))(state);
exports.methods[ActionTypes.CREATE_SUCCESS] = (state, action) => fp.function.compose(saveStatusLens.set(action.payload.status.includes('ADDENDUMS') ? 'ADDENDUMS_SAVED' : 'SAVED'), updateStatusLens.set('STANDBY'), hasUnsavedChangesLens.set(false))(state);
exports.methods[ActionTypes.CREATE_VALIDATION] = (state, action) => fp.function.compose(errorsLens.set(fp.option.some(action.payload.reduce((rv, x) => {
    ;
    (rv[x.key] = rv[x.key] || []).push(x.value);
    return rv;
}, {}))), saveStatusLens.set('FAILED_VALIDATION'))(state);
exports.methods[ActionTypes.CREATE_FAILED] = (state, action) => saveStatusLens.set('FAILED')(state);
exports.methods[ActionTypes.UPDATE_REQUEST] = (state, action) => fp.function.compose(errorsLens.set(fp.option.none), publishLens.set(false), updateStatusLens.set('UPDATING'))(state);
exports.methods[ActionTypes.UPDATE_SUCCESS] = (state, action) => fp.function.compose(updateStatusLens.set('UPDATED'), hasUnsavedChangesLens.set(false))(state);
exports.methods[ActionTypes.UPDATE_VALIDATION] = (state, action) => {
    return fp.function.compose(errorsLens.set(fp.option.some(action.payload.validation.reduce((rv, x) => {
        ;
        (rv[x.key] = rv[x.key] || []).push(x.value);
        return rv;
    }, {}))), updateStatusLens.set('FAILED_VALIDATION'), publishLens.set(action.payload.publish || false))(state);
};
exports.methods[ActionTypes.UPDATE_FAILED] = (state, action) => updateStatusLens.set('FAILED')(state);
// Save opening event start
exports.methods[ActionTypes.SAVE_OPENING_EVENT_REQUEST] = (state, action) => fp.function.compose(errorsLens.set(fp.option.none), openingEventErrorsLens.set(fp.option.none), saveOpeningEventStatusLens.set('UPDATING'))(state);
exports.methods[ActionTypes.SAVE_OPENING_EVENT_SUCCESS] = (state, action) => fp.function.compose(saveOpeningEventStatusLens.set('UPDATED'), hasOpeningEventChangedLens.set(false))(state);
exports.methods[ActionTypes.SAVE_OPENING_EVENT_VALIDATION] = (state, action) => {
    return fp.function.compose(openingEventErrorsLens.set(fp.option.some(action.payload.reduce((rv, x) => {
        ;
        (rv[x.key] = rv[x.key] || []).push(x.value);
        return rv;
    }, {}))), saveOpeningEventStatusLens.set('FAILED_VALIDATION'))(state);
};
exports.methods[ActionTypes.SAVE_OPENING_EVENT_FAILED] = (state, action) => saveOpeningEventStatusLens.set('FAILED')(state);
// Save opening event end
exports.methods[ActionTypes.CLEAR] = (state, action) => (Object.assign({}, exports.initialState));
exports.methods[ActionTypes.CHANGE_STEP] = (state, action) => stepLens.set(action.payload.step)(state);
exports.methods[_BillingActionTypes.ActionTypes.VALUES_SET_BILLING_INFORMATION] = (state, action) => fp.function.compose(valuesLens
    .compose(printOrdersLens)
    .modify(updateFieldLens('billingInformation').set(action.payload)), errorsLens.set(fp.option.none), hasUnsavedChangesLens.set(true))(state);
//# sourceMappingURL=basicInformation.js.map